(() => {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kPracticeProviderUpsellDropdown
   * @restrict E
   * @scope
   * @description
   * Dropdown that displays all active providers in the logged in practice and separates them by
   * whether they have the marketing module. Allows users to select a provider and
   * provides callback functions to be called upon selection.
   *
   * @param {string} defaultProviderGuid Optional. Guid of selected provider upon initialization.
   * @param {function} providerEligibilityValidator Function that takes in a provider as a parameter
   * and determines whether the given provider is eligible. Returns a boolean: true if eligible,
   * false if ineligible.
   * @param {function} onProviderSelected Callback function that is invoked when user selects a provider.
   * Takes in the selected provider as a parameter. Returns true in order to accept the provider selection
   * with the dropdown and false in order to reject the provider selection;
   */

  angular
    .module('kareo.ui.shared.directives.k-practice-provider-upsell-dropdown', [
      'kareo.ui.shared.directives.k-provider-upsell-dropdown-view',
      'kareo.ui.shared.modules.api.user.k-user-service',
      'kareo.ui.shared.modules.authentication.k-roles'
    ])
    .component('kPracticeProviderUpsellDropdown', {
      controller,
      controllerAs: 'vm',
      bindings: {
        defaultProviderGuid: '<?',
        onProviderSelected: '&',
        disableUpsell: '<?'
      },
      template: require('./k-practice-provider-upsell-dropdown.pug')()
    });

  controller.$inject = [
    'K_ROLES',
    'kUserService'
  ];

  function controller(K_ROLES, kUserService) {
    const vm = this;

    vm.providers = [];
    vm.providersToUpsell = [];
    vm.isLoading = false;

    vm.$onInit = init;

    function init() {
      vm.isLoading = true;

      kUserService.getAllUsersForPractice()
        .then((users) => users
          .filter(isProvider)
          .map((user) => (
            {
              firstName: user.firstName,
              isLocked: user.isLocked,
              isMarketingEnabled: hasMarketing(user.providerInfo.products),
              lastName: user.lastName,
              products: user.providerInfo.products,
              providerGuid: user.providerInfo.providerGuid
            }
        ))
      ).then((providers) => {
          vm.providers = providers.filter((p) => p.isMarketingEnabled);
          vm.providersToUpsell = providers.filter((p) => !p.isLocked && !p.isMarketingEnabled);
          if (vm.disableUpsell) {
            vm.providersToUpsell = [];
            vm.providers = providers;
          }
        })
        .finally(() => vm.isLoading = false);
    }

    function isProvider(user) {
      return !!user && user.roles.indexOf(K_ROLES.PROVIDER) !== -1;
    }

    function hasMarketing(products) {
      return !!products && products.KAREO_OFFICE;
    }
  }
})();
